export default "__VITE_ASSET__ib1w0RwO__"